import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  [
    'border-x-border-comp-badge',
    'border-y-border-comp-badge',
    'flex',
    'items-center',
    'justify-center',
    'min-w-sizing-comp-badge-min-width',
    '[&>svg]:size-sizing-comp-badge-icon',
    'w-fit',
  ],
  {
    variants: {
      variant: {
        info: [
          'bg-color-comp-badge-info-container',
          'text-color-comp-badge-info-on-container',
          'border-color-comp-badge-info-border',
        ],
        success: [
          'bg-color-comp-badge-success-container',
          'text-color-comp-badge-success-on-container',
          'border-color-comp-badge-success-border',
        ],
        warning: [
          'bg-color-comp-badge-warning-container',
          'text-color-comp-badge-warning-on-container',
          'border-color-comp-badge-warning-border',
        ],
        danger: [
          'bg-color-comp-badge-danger-container',
          'text-color-comp-badge-danger-on-container',
          'border-color-comp-badge-danger-border',
        ],
        neutral: [
          'bg-color-comp-badge-neutral-container',
          'text-color-comp-badge-neutral-on-container',
          'border-color-comp-badge-neutral-border',
        ],
        primary: [
          'bg-color-comp-badge-primary-container',
          'text-color-comp-badge-primary-on-container',
          'border-color-comp-badge-primary-border',
        ],
      },
      size: {
        tiny: [
          'rounded-radius-comp-badge-tiny',
          'py-spacing-comp-badge-tiny-vertical',
          'px-spacing-comp-badge-tiny-horizontal',
        ],
        medium: [
          'rounded-radius-comp-badge-medium',
          'py-spacing-comp-badge-medium-vertical',
          'px-spacing-comp-badge-medium-horizontal',
        ],
      },
      truncate: {
        true: 'max-w-sizing-comp-badge-max-width',
        false: '',
      },
    },
    defaultVariants: {
      variant: 'info',
      size: 'medium',
      truncate: true,
    },
  },
);
